module.exports = __webpack_public_path__ + "img/biaodan.46053860.png";